import React from "react";

const CongratsModal = () => {
  return (
    <div style={{height: "100%", backgroundColor: "#e7eaef", display: "flex", borderRadius: "1rem"}}>
         <div style={{width: "100%", margin: "auto", display: "flex", padding: "0 1rem", height: "23rem", maxWidth: "50rem"}}>
            <div style={{backgroundColor: "#ffffff", borderRadius: "10px 0 0 10px", width: "60%", padding: "0 1rem", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center"}}>
                <h2 style={{fontWeight: "bold", margin: 0}}>Congratulations!</h2>
                <small style={{color: "#2bc18d", marginBottom: "1.4rem"}}>C2Connect is successfully installed on your desktop.</small>
                <div style={{backgroundColor: "#e7eaef", borderRadius: ".7rem", padding: "1.4rem", marginBottom: "1.4rem"}}>
                  <p style={{marginBottom: 0}}>C2Connect is started/launched from the User Portal within C2Perform. Please close this window and launch C2Connect from within C2Perform.</p>
                </div>
                <div>
                  <button style={{backgroundColor: "#2bc18d", color: "#ffffff", padding: "0 0.5rem", display: "flex", justifyContent: "center", alignItems: "center", fontSize: ".9rem", position: "relative", border: ".15rem solid transparent", height: "2.3rem", borderRadius: "0.4rem", lineHeight: "1.5", cursor: "pointer", fontWeight: "bold", width: "100%"}}>
                    Close this screen
                    <svg width="24" height="24" viewBox="0 0 24 24" style={{position: "absolute", right: ".25rem"}}><path fill="#fff" d="m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"></path></svg>
                  </button>
                </div>
            </div>
            <div style={{borderRadius: "0 10px 10px 0;", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", color: "#ffffff", background: "url(../../images/pexels-cottonbr.png) no-repeat", backgroundSize: "cover", backgroundPosition: "center", position: "relative", overflow: "hidden", width: "40%"}}>
              <div style={{zIndex: "1", display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", flexDirection: "column"}}>
                <img src="../assets/images/logo-icon-light.png" alt="Logo icon" style={{width: "20%"}} />
                <p style={{display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", bottom: 0}}>
                  <small style={{marginRight: ".5rem", fontSize: "80%", lineHeight: "1.7em"}}>Performance Management System|Powered by</small>
                  <a href="void(0)" style={{display: "flex", alignItems: "center", width: "25%"}}>
                    <img src="./assets/images/c2-perform-logo.png" alt="Logo"  style={{width: "100%"}} />
                  </a>
                </p>
              </div>
            </div>
         </div>
    </div>
  );
};

export default CongratsModal;
